module.exports = __webpack_public_path__ + "media/styles/images/svg/airplane-white-181fc2f73f67b56dcd9aa0b774117a60.svg";